
export default {
  async asyncData({ app, store, error }) {
    if (!process.server) return
  },
  name: 'IndexPage'
}
